export function formatDate(dateStr) {
  if (!dateStr) return '—';
  const [year, month, day] = dateStr.split('-');
  return `${day}/${month}/${year}`;
}

export function formatTime(timeStr) {
  if (!timeStr) return '—';
  const [hourStr, minuteStr] = timeStr.split(':');
  let hour = parseInt(hourStr);
  const minute = parseInt(minuteStr);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  hour = hour % 12 || 12;
  return minute === 0
    ? `${hour} ${ampm}`
    : `${hour}:${String(minute).padStart(2, '0')} ${ampm}`;
}

export function formatTimeRange(start, end) {
  return `${formatTime(start)} - ${formatTime(end)}`;
}
